var MpPageLanding;

(function() {
    if (!document.querySelector('#vue-landing')) {
        return;
    }

    MpPageLanding = new Vue({
        el: '#vue-landing',

        mixins: [MpLeadersBlock],

        data: {

            highlightsCarousel: null,
            gallerySwiper: null,

            isInitialized: false,
        },

        computed: {},

        methods:{

            initHighlightsCarousel: function() {
                this.highlightsCarousel = new Swiper(this.$refs.highlightsCarousel, {
                    effect: 'fade',
                    watchOverflow: true,
                    simulateTouch: false,
                    pagination: {
                        el: '.swiper-pagination',
                        // dynamicBullets: true,
                        clickable: true
                    }
                });
            },

            initGallery: function() {
                this.gallerySwiper = new Swiper(this.$refs.gallerySlider, {
                    slidesPerView: 'auto',
                    freeMode: true,
                });
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;

                if (this.$refs.highlightsCarousel) {
                    this.initHighlightsCarousel();
                }

                if (this.$refs.gallerySlider) {
                    this.initGallery();
                }

                if (this.$refs.ssrLeadersList) {
                    this.initLeadersPanel();
                }
            },
        },

        filters: {},

        mounted: function() {
            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        }
    });

})();
